/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { VisitorChartDataDto } from '../models/visitor-chart-data-dto';
import { visitorControllerGetDeviceType } from '../fn/visitor/visitor-controller-get-device-type';
import { VisitorControllerGetDeviceType$Params } from '../fn/visitor/visitor-controller-get-device-type';
import { visitorControllerGetIncomingPage } from '../fn/visitor/visitor-controller-get-incoming-page';
import { VisitorControllerGetIncomingPage$Params } from '../fn/visitor/visitor-controller-get-incoming-page';
import { visitorControllerGetPopularPage } from '../fn/visitor/visitor-controller-get-popular-page';
import { VisitorControllerGetPopularPage$Params } from '../fn/visitor/visitor-controller-get-popular-page';
import { visitorControllerGetTotalVisitors } from '../fn/visitor/visitor-controller-get-total-visitors';
import { VisitorControllerGetTotalVisitors$Params } from '../fn/visitor/visitor-controller-get-total-visitors';
import { visitorControllerGetVisitors } from '../fn/visitor/visitor-controller-get-visitors';
import { VisitorControllerGetVisitors$Params } from '../fn/visitor/visitor-controller-get-visitors';
import { visitorControllerTrackVisitor } from '../fn/visitor/visitor-controller-track-visitor';
import { VisitorControllerTrackVisitor$Params } from '../fn/visitor/visitor-controller-track-visitor';
import { VisitorDto } from '../models/visitor-dto';

@Injectable({ providedIn: 'root' })
export class VisitorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `visitorControllerGetVisitors()` */
  static readonly VisitorControllerGetVisitorsPath = '/api/visitor/search';

  /**
   * 방문자 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitorControllerGetVisitors()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorControllerGetVisitors$Response(params: VisitorControllerGetVisitors$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<VisitorDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = visitorControllerGetVisitors(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 방문자 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitorControllerGetVisitors$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorControllerGetVisitors(params: VisitorControllerGetVisitors$Params, context?: HttpContext): Observable<{
'items': Array<VisitorDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.visitorControllerGetVisitors$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<VisitorDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<VisitorDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `visitorControllerGetTotalVisitors()` */
  static readonly VisitorControllerGetTotalVisitorsPath = '/api/visitor/total-visit';

  /**
   * 총 방문자 수 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitorControllerGetTotalVisitors()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorControllerGetTotalVisitors$Response(params?: VisitorControllerGetTotalVisitors$Params, context?: HttpContext): Observable<StrictHttpResponse<VisitorChartDataDto>> {
    const obs = visitorControllerGetTotalVisitors(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 총 방문자 수 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitorControllerGetTotalVisitors$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorControllerGetTotalVisitors(params?: VisitorControllerGetTotalVisitors$Params, context?: HttpContext): Observable<VisitorChartDataDto> {
    const resp = this.visitorControllerGetTotalVisitors$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VisitorChartDataDto>): VisitorChartDataDto => r.body)
    );
  }

  /** Path part for operation `visitorControllerGetPopularPage()` */
  static readonly VisitorControllerGetPopularPagePath = '/api/visitor/popular-page';

  /**
   * 인기 페이지 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitorControllerGetPopularPage()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorControllerGetPopularPage$Response(params?: VisitorControllerGetPopularPage$Params, context?: HttpContext): Observable<StrictHttpResponse<VisitorChartDataDto>> {
    const obs = visitorControllerGetPopularPage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 인기 페이지 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitorControllerGetPopularPage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorControllerGetPopularPage(params?: VisitorControllerGetPopularPage$Params, context?: HttpContext): Observable<VisitorChartDataDto> {
    const resp = this.visitorControllerGetPopularPage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VisitorChartDataDto>): VisitorChartDataDto => r.body)
    );
  }

  /** Path part for operation `visitorControllerGetIncomingPage()` */
  static readonly VisitorControllerGetIncomingPagePath = '/api/visitor/incoming-page';

  /**
   * 유입 페이지 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitorControllerGetIncomingPage()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorControllerGetIncomingPage$Response(params?: VisitorControllerGetIncomingPage$Params, context?: HttpContext): Observable<StrictHttpResponse<VisitorChartDataDto>> {
    const obs = visitorControllerGetIncomingPage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 유입 페이지 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitorControllerGetIncomingPage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorControllerGetIncomingPage(params?: VisitorControllerGetIncomingPage$Params, context?: HttpContext): Observable<VisitorChartDataDto> {
    const resp = this.visitorControllerGetIncomingPage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VisitorChartDataDto>): VisitorChartDataDto => r.body)
    );
  }

  /** Path part for operation `visitorControllerGetDeviceType()` */
  static readonly VisitorControllerGetDeviceTypePath = '/api/visitor/device-type';

  /**
   * 총 방문자 수 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitorControllerGetDeviceType()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorControllerGetDeviceType$Response(params?: VisitorControllerGetDeviceType$Params, context?: HttpContext): Observable<StrictHttpResponse<VisitorChartDataDto>> {
    const obs = visitorControllerGetDeviceType(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 총 방문자 수 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitorControllerGetDeviceType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  visitorControllerGetDeviceType(params?: VisitorControllerGetDeviceType$Params, context?: HttpContext): Observable<VisitorChartDataDto> {
    const resp = this.visitorControllerGetDeviceType$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<VisitorChartDataDto>): VisitorChartDataDto => r.body)
    );
  }

  /** Path part for operation `visitorControllerTrackVisitor()` */
  static readonly VisitorControllerTrackVisitorPath = '/api/visitor';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `visitorControllerTrackVisitor()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitorControllerTrackVisitor$Response(params: VisitorControllerTrackVisitor$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = visitorControllerTrackVisitor(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `visitorControllerTrackVisitor$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  visitorControllerTrackVisitor(params: VisitorControllerTrackVisitor$Params, context?: HttpContext): Observable<void> {
    const resp = this.visitorControllerTrackVisitor$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
